
// ============================================== //

// DOM READY  //

// ============================================== //


// ============================================== Mobile Navigation //

var mobileNav = {
  init: function () {

    var menuPos = 0;
    var primaryNavHeight = 0;

    var elHeader = document.querySelector('.header');
    var elMenuBtn = elHeader.querySelector('.js-menu-btn');
    var elPrimaryNavContainer = elHeader.querySelector('.primary-nav-container');
    var elPrimaryNav = elHeader.querySelector('.primary-nav');
    
    if(!elMenuBtn || !elPrimaryNav) return;

    // OPEN / CLOSE MENU
    elMenuBtn.addEventListener('click', function(e){
      e.preventDefault();
      
      elHeader.classList.toggle('mob-nav-open');

      if (elHeader.classList.contains('mob-nav-open')) {
        // get height
        primaryNavHeight = elPrimaryNav.clientHeight;
        // add height to element
        elPrimaryNavContainer.style.maxHeight = primaryNavHeight + 'px';
      } else {
        // remove height from element
        elPrimaryNavContainer.style.maxHeight = '0';
        window.setTimeout(function(){
          // reset menu
          elPrimaryNav.classList.remove('menu-pos-' + menuPos);
          menuPos = 0;
          elPrimaryNav.classList.add('menu-pos-' + menuPos);
        },300)
        
      }
    });

    // SUB MENUS

    elPrimaryNav.classList.add('menu-pos-' + menuPos);

    var elUlChildren = elPrimaryNav.querySelectorAll('ul');

    // add back buttons
    elUlChildren.forEach(function(el){
      var elLi = document.createElement('li');
      elLi.classList.add('nav-mob','icon-sub-back-li');
      el.insertBefore(elLi, el.firstChild);
      elLi.innerHTML = '<a href="#" class="icon-sub-back">Back<\/a>';
    });

    // matchmedia
    mm = window.matchMedia('(min-width: 45em)');

    // click forwards
    elPrimaryNav.addEventListener('click', function(e){
      
      // disable on tablet
      if(mm.matches) return;

      var elA = e.target.closest('a');
      if(!elA) return;

      if(elA.classList.contains('icon-sub')){
        e.preventDefault();
        // Set defaults for main menu
        elPrimaryNavContainer.style.height = primaryNavHeight + 'px';
        elPrimaryNavContainer.style.maxHeight = primaryNavHeight + 'px';
        // hide all subs
        var elSubs = elPrimaryNav.querySelectorAll('ul');
        elSubs.forEach(function(el){
          el.style.display = 'none';
        });
        // show next sub
        var elSub = elA.parentNode.querySelector('ul');
        elSub.style.display = 'block';
        // Get hight of new menu
        var subHeight = elSub.clientHeight;
        elPrimaryNavContainer.style.height = subHeight + 'px';
        elPrimaryNavContainer.style.maxHeight = subHeight + 'px';
        // Outer height
        elPrimaryNavContainer.style.maxHeight = subHeight + 'px';
        // move forwards
        elPrimaryNav.classList.remove('menu-pos-' + menuPos);
        menuPos++;
        elPrimaryNav.classList.add('menu-pos-' + menuPos);
      }

      if(elA.classList.contains('icon-sub-back')){
        e.preventDefault();
        // Set new height
        if (menuPos == 1) {// if going back to home
          elPrimaryNavContainer.style.height = primaryNavHeight + 'px';
          elPrimaryNavContainer.style.maxHeight = primaryNavHeight + 'px';
          // Outer height
          elPrimaryNavContainer.style.maxHeight = primaryNavHeight + 'px';
        } else {
          var parentSub = elA.parentNode.parentNode.parentNode.parentNode.clientHeight;
          var subHeight = parentSub.clientHeight;
          elPrimaryNavContainer.style.height = subHeight + 'px';
          elPrimaryNavContainer.style.maxHeight = subHeight + 'px';
          elPrimaryNavContainer.style.maxHeight = subHeight + 'px';
        }
        // move back
        elPrimaryNav.classList.remove('menu-pos-' + menuPos);
        menuPos--;
        elPrimaryNav.classList.add('menu-pos-' + menuPos);
      }

    });

    // click backwards


  },
  destroy: function () {

  }
}

// ============================================== FAQs popup  //
var setFaqs = {
  init: function () {

      var elBlock = document.querySelector('.js-faqs');

      var clickEvt = function(e){
          var el = e.target;

          // Closest captures self as well a parents
          if (!el.closest('.js-faqs-link')) return;

          // Button clicked
          e.preventDefault();

          // Close all open elements
          var elOpenItems = elBlock.querySelectorAll('.js-faqs-item.open'); // NodeList
          var elItem = el.closest('.js-faqs-item');

          if (elItem.classList.contains('open')){
              elItem.classList.remove('open');
              var elContent = elItem.querySelector('.js-faqs-content');
              elContent.setAttribute('aria-expanded', false);
          }else{

              if(elOpenItems && elOpenItems.length>0){
                  forEachNode(elOpenItems, function (i, el) {
                      el.classList.remove('open');
                      var elContent = el.querySelector('.js-faqs-content');
                      elContent.setAttribute('aria-expanded', false);
                  });
              }
  
              if(elItem){
                  elItem.classList.add('open');
                  var elContent = elItem.querySelector('.js-faqs-content');
                  elContent.setAttribute('aria-expanded', true);
                  //
                  /*ScrollIt({
                      pos: elItem,
                      speed: 400,
                      offset: 90,
                      //callback: pauseCallback
                  }).runScroll();*/
  
              }

          }

      }

      // Attach open event
      on('click', document, clickEvt);

  }
}

// Vanilla JS DOM Ready
document.addEventListener('DOMContentLoaded', function() {

  // MOBILE NAV

  setTimeout(function () {
    mobileNav.init();
  }, 200);


  // SWIPER
  
  const elSwiper = document.querySelectorAll('.js-swiper');

  elSwiper.forEach((el)=>{
    const elSlides = el.querySelectorAll('.swiper-slide');

    if(elSlides.length > 1){
      const elParent = el.parentNode.parentNode;
      const elPag = elParent.querySelector('.swiper-pagination');
      const elNavNext = elParent.querySelector('.swiper-button-next');
      const elNavPrev = elParent.querySelector('.swiper-button-prev');

      const pagination = {};
      const navigation = {};

      if(elPag){
        pagination['el'] = elPag;
        pagination['clickable'] = true;
      }

      if(elNavPrev && elNavNext){
        navigation['nextEl'] = elNavNext;
        navigation['prevEl'] = elNavPrev;
      }

      const options = {
        spaceBetween: 0,
        slidesPerView: 1,
        pagination: pagination,
        navigation: navigation
      }
      
      new Swiper(el, options);

    }

  });

  // Google maps
  var elGmaps = document.querySelectorAll('.js-map'); // NodeList
  if(elGmaps && elGmaps.length>0){
      forEachNode(elGmaps, function (i, el) {
          initGmap.init(el);
      });
  }


  // Vanilla JS DOM Ready
  setFaqs.init();

  // Enquiry form events
  document.addEventListener( 'wpcf7submit', function( e ) {
    const el = e.target.closest('section');
    el.scrollIntoView({ behavior: "smooth" });
  }); 

  document.addEventListener( 'wpcf7mailsent', function( e ) {
    console.log('wpcf7mailsent !!!');
    // window.dataLayer.push({
    // "event" : "cf7submission",
    // "formId" : event.detail.contactFormId,
    // "response" : event.detail.inputs
    // })
   }); 

  const elNewsFeed = document.querySelector('.js-news-feed');

  if(elNewsFeed){

      // Newsfeed js
    fetch('/wp-json/site/v1/news')
      .then(response => response.json())
      .then(news => {

        if(news?.data?.status === 404){
          elNewsFeed.innerHTML = '<p class="date">Could not load news feed</p>';
          return;
        }

        elNewsFeed.innerHTML = `
            <p class="date">${news.date}</p>
            <h3>
                <a href="${news.url}">
                    ${news.title}
                </a>
            </h3>
            <p>${news.content}</p>
        `;

      });
  }


});
